export const nextUnit = (rng: number): { value: number; rng: number } => {
  let t = (rng + 0x6d2b79f5) | 0;
  t = Math.imul(t ^ (t >>> 15), t | 1);
  t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
  const value = ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  return { value, rng: t | 0 };
};

export const shuffleInPlace = <T>(items: T[], startRng: number): { items: T[]; rng: number } => {
  const next = [...items];
  let rng = startRng;
  for (let i = next.length - 1; i > 0; i--) {
    const roll = nextUnit(rng);
    rng = roll.rng;
    const j = Math.floor(roll.value * (i + 1));
    [next[i], next[j]] = [next[j], next[i]];
  }
  return { items: next, rng };
};
